<!-- Filter Section -->
<div class="filter-section">
  <div class="controls">
    <!-- Basic Filters -->
    <div class="filter-row">
      @if(!this.commonService.isGenericFlowActive()){
      <mat-form-field appearance="outline" class="filter-field" >
        <mat-label>{{ config.categoryLabel }}</mat-label>
        <mat-select [(ngModel)]="category" (selectionChange)="onCategoryChange()">
          <mat-option *ngFor="let option of categoryOptions" [value]="option">
            {{ option }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      }
      <mat-form-field appearance="outline" class="filter-field">
        <mat-label>{{ config.countryLabel }}</mat-label>
        <mat-select [(ngModel)]="country" (selectionChange)="onCountryChange()">
          <mat-option *ngFor="let option of countryOptions" [value]="option">
            {{ option }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <!-- Horizontal Selector Bar (Replaces Dynamic Entity Search) -->
    <app-horizontal-selector-bar [entityType]="config.entityType" [maxCompetitors]="6"
      [availableOptions]="availableOptions" [selectedItems]="selectorItems"
      (selectionChange)="onSelectorSelectionChange($event)" (compareClick)="onSelectorCompareClick($event)">
    </app-horizontal-selector-bar>

    <!-- Original Dynamic Entity Search (Commented Out) -->
    <!--
    <app-dynamic-university-search [country]="country" [category]="category" [maxEntities]="10"
      [placeholder]="config.searchPlaceholder" (universitiesChange)="onEntitiesChange($event)">
    </app-dynamic-university-search>
    -->

    <!-- Original Analyze Button (Commented Out - Now handled by horizontal selector) -->
    <!--
    <button mat-raised-button color="primary" (click)="onAnalyzeClick()" [disabled]="!isAnalyzeButtonEnabled()">
      <mat-icon>search</mat-icon>
      {{ config.buttonText }}
    </button>
    -->
  </div>
</div>

<!-- Error Display -->
@if(error){
<div class="error">{{ error }}</div>
}
